import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./HomePage";
import RandomQuiz from "./RandomQuiz";
import excelIcon from "./assets/excel.png";
import sheetsIcon from "./assets/google-sheets.png";
import "./HomePage.css"; // здесь описана сетка и анимация
import ExcelPractice from "./ExcelPractice";

function App() {
  const floatingIcons = [
    { src: excelIcon,  top: "5%",  left: "10%",  size: 60, delay: "0s" },
    { src: sheetsIcon, top: "15%", left: "70%",  size: 50, delay: "2s" },
    { src: excelIcon,  top: "25%", left: "40%",  size: 80, delay: "4s" },
    { src: sheetsIcon, top: "35%", left: "20%",  size: 45, delay: "1s" },
    { src: excelIcon,  top: "45%", left: "85%",  size: 55, delay: "3s" },
    { src: sheetsIcon, top: "55%", left: "5%",   size: 65, delay: "5s" },
    { src: excelIcon,  top: "65%", left: "50%",  size: 75, delay: "6s" },
    { src: sheetsIcon, top: "75%", left: "25%",  size: 40, delay: "7s" },
    { src: excelIcon,  top: "85%", left: "60%",  size: 70, delay: "8s" },
    { src: sheetsIcon, top: "90%", left: "80%",  size: 50, delay: "9s" },
  ];

  return (
    <div className="excel-grid min-h-screen w-full relative overflow-hidden">
      {/* Плавающие иконки — общий слой */}
      {floatingIcons.map((icon, index) => (
        <img
          key={index}
          src={icon.src}
          alt="icon"
          className="floating-icon"
          style={{
            top: icon.top,
            left: icon.left,
            width: icon.size,
            height: icon.size,
            animationDelay: icon.delay,
          }}
        />
      ))}

      {/* Контент приложения */}
      <div className="content z-10">
        <Router>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/quiz" element={<RandomQuiz />} />
            <Route path="/practice" element={<ExcelPractice />} />
          </Routes>
        </Router>
      </div>  
    </div>
  );
}

export default App;
